import { lazy } from 'react'

export const KitLifeStyle = lazy(() => import('./KitLifeStyle'))
